import { z } from 'zod';
import { DEFAULT_COST_CATEGORY_COLOR } from '@/features/dashboard/costCategories/types/CostCategory.utils.ts';
import { HEX_COLOR_REGEX } from '@/schemas/hexColor.ts';

export const costCategorySchema = z.object({
  name: z.string().min(1, 'Nazwa jest wymagana'),
  color: z
    .string()
    .regex(HEX_COLOR_REGEX, 'Kolor musi być w formacie #RRGGBB')
    .default(DEFAULT_COST_CATEGORY_COLOR),
});

export type CostCategoryFormData = z.infer<typeof costCategorySchema>;
export type CostCategoryInputData = z.input<typeof costCategorySchema>;

export const costCategoryDefaultValues: CostCategoryInputData = {
  name: '',
  color: DEFAULT_COST_CATEGORY_COLOR,
};
